const AGENT_BASE = window._env_?.REACT_APP_TEMPLATE_AGENT_URL || 'http://localhost:8001';
const DATA_ENGINE_BASE = window._env_?.REACT_APP_DATA_ENGINE_URL || 'http://localhost:8002';

export const kpiApi = {
  listKpis: async (orgId = 'default') => {
    const r = await fetch(`${DATA_ENGINE_BASE}/api/kpis?org_id=${orgId}`);
    if (!r.ok) return [];
    const json = await r.json();
    return json.data || [];
  },

  executeKpi: async (kpiId, body) => {
    const r = await fetch(`${DATA_ENGINE_BASE}/api/kpis/${kpiId}/execute`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (!r.ok) throw new Error(`Execute failed: ${r.status}`);
    const json = await r.json();
    return json.data || json;
  },

  // SSE streaming goes direct to template-agent
  // AgentChat calls: api.streamChat(body, signal) where body = {message, user_id, thread_id, model, images, context}
  streamChat: (body, signal) => {
    return fetch(`${AGENT_BASE}/chat/kpi-agent`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'text/event-stream' },
      body: JSON.stringify(body),
      signal,
    });
  },

  getThreads: async (userId = 'admin') => {
    const r = await fetch(`${AGENT_BASE}/threads?user_id=${userId}&agent=kpi-agent`);
    if (!r.ok) throw new Error(`Failed to fetch threads: ${r.status}`);
    return r.json();
  },

  getThread: async (threadId, userId = 'admin') => {
    const r = await fetch(`${AGENT_BASE}/threads/${threadId}?user_id=${userId}`);
    if (!r.ok) throw new Error(`Failed to fetch thread: ${r.status}`);
    return r.json();
  },

  getModels: async () => {
    const r = await fetch(`${AGENT_BASE}/models`);
    if (!r.ok) throw new Error(`Failed to fetch models: ${r.status}`);
    return r.json();
  },

  getCubeMeta: async () => {
    const r = await fetch(`${DATA_ENGINE_BASE}/api/cube/meta`);
    if (!r.ok) return null;
    return r.json();
  },
};
